import React, { useState, useEffect } from "react";
import { Wrapper } from "./PaymentExpenses.styled";
import { callGetApiWithAuth, callPostApiWithAuth } from "utils/api";
import { Loading, Modal, SuccessNotification, Drawer, Row, Col, Button } from "components/common";
import { useLayoutEffect } from "react";
import ExpensesCard from "components/pageSection/PaymentExpenses/ExpensesCard";
import ExpensesTable from "components/pageSection/PaymentExpenses/ExpensesTable";
import PaymentExpensesModal from "components/pageSection/PaymentExpenses/PaymentExpensesModal";
import { CheckOutlined } from "@ant-design/icons";

const PaymentExpenses = () => {
    const [userData, setUserData] = useState([]);
    const [expenseData, setExpenseData] = useState([]);
    const [leadData, setLeadData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [cards, setCards] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [getExpenseData, setGetExpenseData] = useState([]);
    const [editData, setEditData] = useState(null);
    const [isdrawOpen, setIsdrawOpen] = useState(false);
    const [sortBy, setSortBy] = useState("");

    const deleteExpense = (id) => {
        callPostApiWithAuth(
            "expense",
            {
                method: "delete",
                expenseId: id,
            },
            onSuccessDeleteExpense,
            onFailDeleteExpense
        );
    };

    const onSuccessDeleteExpense = () => {
        getExpenseDataApi();
        SuccessNotification("Expense Deleted");
    };
    const onFailDeleteExpense = () => {};

    const getAllUserApi = () => {
        callGetApiWithAuth("allUsers", onSuccessAllUserApi, onFailedAllUserApi);
    };

    const getExpensesApi = () => {
        callGetApiWithAuth("getAllExpensCategory", onSuccessExpenseApi, onFailedExpenseApi);
    };

    const getExpenseDataApi = () => {
        callGetApiWithAuth("getAllExpenses", onSuccessExpenseData, onFailedExpenseData);
    };

    const onSuccessExpenseData = (data) => {
        setGetExpenseData(data);
        // setIsLoading(false);
    };

    const onFailedExpenseData = (err) => {
        console.log(err);
    };

    const getLeadApi = () => {
        callGetApiWithAuth("allLeads", onSuccessLeadApi, onFailedLeadApi);
    };

    const onSuccessLeadApi = (data) => {
        setLeadData(data);
        // setIsLoading(false);
    };

    const onFailedLeadApi = (err) => {
        console.log(err);
    };
    const onSuccessAllUserApi = (data) => {
        setUserData(data);
        // setIsLoading(false);
    };

    const onFailedAllUserApi = (err) => {
        console.log(err);
    };

    const onSuccessExpenseApi = (data) => {
        setExpenseData(data);
        // setIsLoading(false);
    };

    const onFailedExpenseApi = (err) => {
        console.log(err);
    };

    useEffect(() => {
        getAllUserApi();
        getExpensesApi();
        getLeadApi();
        getExpenseDataApi();
        // setIsLoading(true);
    }, []);

    useLayoutEffect(() => {
        function updateSize() {
            if (window.innerWidth < 1500) {
                setCards(true);
            } else {
                return setCards(false);
            }
        }
        window.addEventListener("resize", updateSize);
        updateSize();
        return () => window.removeEventListener("resize", updateSize);
    }, []);

    useEffect(() => {
        if (sortBy) {
            if (sortBy == "invoiceDate") {
                let dLeads = [...getExpenseData];
                setGetExpenseData([
                    ...dLeads.sort((a, b) => {
                        if (a?.invoiceDate > b?.invoiceDate) {
                            return -1;
                        }
                        if (a?.invoiceDate < b?.invoiceDate) {
                            return 1;
                        }
                        return 0;
                    }),
                ]);
            } else if (sortBy == "description") {
                let dLeads = [...getExpenseData];
                setGetExpenseData([
                    ...dLeads.sort((a, b) => {
                        if (a?.description > b?.description) {
                            return 1;
                        }
                        if (a?.description < b?.description) {
                            return -1;
                        }
                        return 0;
                    }),
                ]);
                setGetExpenseData([...dLeads.sort((a, b) => a?.setter?.name - b?.setter?.name)]);
            } else if (sortBy == "category") {
                let dLeads = [...getExpenseData];
                setGetExpenseData([
                    ...dLeads.sort((a, b) => {
                        if (a?.category > b?.category) {
                            return -1;
                        }
                        if (a?.category < b?.category) {
                            return 1;
                        }
                        return 0;
                    }),
                ]);
            } else if (sortBy == "amount") {
                let dLeads = [...getExpenseData];
                setGetExpenseData([
                    ...dLeads.sort((a, b) => {
                        if (a?.amount > b?.amount) {
                            return -1;
                        }
                        if (a?.amount < b?.amount) {
                            return 1;
                        }
                        return 0;
                    }),
                ]);
            } else if (sortBy == "status") {
                let dLeads = [...getExpenseData];
                setGetExpenseData([
                    ...dLeads.sort((a, b) => {
                        if (a?.status > b?.status) {
                            return -1;
                        }
                        if (a?.status < b?.status) {
                            return 1;
                        }
                        return 0;
                    }),
                ]);
            } else if (sortBy == "lead") {
                let dLeads = [...getExpenseData];
                setGetExpenseData([
                    ...dLeads.sort((a, b) => {
                        if (a?.leadName?.firstName > b?.leadName?.firstName) {
                            return 1;
                        }
                        if (a?.leadName?.firstName < b?.leadName?.firstName) {
                            return -1;
                        }
                        return 0;
                    }),
                ]);
            } else if (sortBy == "userId") {
                let dLeads = [...getExpenseData];
                setGetExpenseData([
                    ...dLeads.sort((a, b) => {
                        if (a?.userId > b?.userId) {
                            return 1;
                        }
                        if (a?.userId < b?.userId) {
                            return -1;
                        }
                        return 0;
                    }),
                ]);
            }
        }
    }, [sortBy]);

    return (
        <Wrapper>
            {cards ? (
                isLoading ? (
                    <Loading />
                ) : (
                    <ExpensesCard
                        userData={userData}
                        deleteExpense={deleteExpense}
                        leadData={leadData}
                        expenseData={expenseData}
                        getExpenseData={getExpenseData}
                        setIsOpen={setIsOpen}
                        setExpenseData={setExpenseData}
                        setEditData={setEditData}
                        editData={editData}
                        setIsdrawOpen={setIsdrawOpen}
                    />
                )
            ) : (
                <ExpensesTable
                    setIsOpen={setIsOpen}
                    getExpenseData={getExpenseData}
                    expenseData={expenseData}
                    isLoading={isLoading}
                    userData={userData}
                    deleteExpense={deleteExpense}
                    leadData={leadData}
                    setEditData={setEditData}
                    editData={editData}
                />
            )}

            <Modal
                isOpen={isOpen}
                title={editData ? "Edit Expense" : "Add New Expense"}
                className="payment-modal"
                footer={null}
                toggleModal={() => {
                    setIsOpen(false);
                }}
            >
                <PaymentExpensesModal
                    getExpenseDataApi={getExpenseDataApi}
                    userData={userData}
                    expenseData={expenseData}
                    setIsOpen={setIsOpen}
                    leadData={leadData}
                    editData={editData}
                />
            </Modal>

            <Drawer
                title="Sort Expenses By."
                placement="bottom"
                className="bottom-drawer"
                onClose={() => {
                    setIsdrawOpen(false);
                }}
                visible={isdrawOpen}
            >
                <div style={{ padding: "15px" }}>
                    <Row>
                        <Col span={24}>
                            <Row>
                                <Col span={24}>
                                    <p
                                        className="label"
                                        onClick={() => {
                                            setSortBy("invoiceDate");
                                            setIsdrawOpen(false);
                                        }}
                                        style={{
                                            fontWeight: sortBy == "invoiceDate" ? "bold" : "normal",
                                        }}
                                    >
                                        Invoice Date
                                        {sortBy == "invoiceDate" && (
                                            <CheckOutlined
                                                style={{
                                                    color: "green",
                                                    float: "right",
                                                }}
                                            />
                                        )}
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <p
                                        className="label"
                                        onClick={() => {
                                            setSortBy("description");
                                            setIsdrawOpen(false);
                                        }}
                                        style={{
                                            fontWeight: sortBy == "description" ? "bold" : "normal",
                                        }}
                                    >
                                        Description
                                        {sortBy == "description" && (
                                            <CheckOutlined
                                                style={{
                                                    color: "green",
                                                    float: "right",
                                                }}
                                            />
                                        )}
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <p
                                        className="label"
                                        onClick={() => {
                                            setSortBy("category");
                                            setIsdrawOpen(false);
                                        }}
                                        style={{
                                            fontWeight: sortBy == "category" ? "bold" : "normal",
                                        }}
                                    >
                                        Category Name
                                        {sortBy == "category" && (
                                            <CheckOutlined
                                                style={{
                                                    color: "green",
                                                    float: "right",
                                                }}
                                            />
                                        )}
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <p
                                        className="label"
                                        onClick={() => {
                                            setSortBy("amount");
                                            setIsdrawOpen(false);
                                        }}
                                        style={{
                                            fontWeight: sortBy == "amount" ? "bold" : "normal",
                                        }}
                                    >
                                        Amount
                                        {sortBy == "amount" && (
                                            <CheckOutlined
                                                style={{
                                                    color: "green",
                                                    float: "right",
                                                }}
                                            />
                                        )}
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <p
                                        className="label"
                                        onClick={() => {
                                            setSortBy("status");
                                            setIsdrawOpen(false);
                                        }}
                                        style={{
                                            fontWeight: sortBy == "status" ? "bold" : "normal",
                                        }}
                                    >
                                        Status
                                        {sortBy == "status" && (
                                            <CheckOutlined
                                                style={{
                                                    color: "green",
                                                    float: "right",
                                                }}
                                            />
                                        )}
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <p
                                        className="label"
                                        onClick={() => {
                                            setSortBy("lead");
                                            setIsdrawOpen(false);
                                        }}
                                        style={{
                                            fontWeight: sortBy == "lead" ? "bold" : "normal",
                                        }}
                                    >
                                        Lead
                                        {sortBy == "lead" && (
                                            <CheckOutlined
                                                style={{
                                                    color: "green",
                                                    float: "right",
                                                }}
                                            />
                                        )}
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <p
                                        className="label"
                                        onClick={() => {
                                            setSortBy("userId");
                                            setIsdrawOpen(false);
                                        }}
                                        style={{
                                            fontWeight: sortBy == "userId" ? "bold" : "normal",
                                        }}
                                    >
                                        User
                                        {sortBy == "userId" && (
                                            <CheckOutlined
                                                style={{
                                                    color: "green",
                                                    float: "right",
                                                }}
                                            />
                                        )}
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </Drawer>
        </Wrapper>
    );
};

export default PaymentExpenses;
